import React from 'react';
import MenuLink from './MenuLink';
import ChildMenus from './ChildMenus';

export default function ListSubMenu(item) {
    if (window.location.pathname.includes(item.item.folder)) {
        return (
            <li className={'active'}>
                <MenuLink item={item.item} />
                <ChildMenus submenu={item.item.submenu} />
            </li>
        );
    } else {
        return (
            <li>
                <MenuLink item={item.item} />
                <ChildMenus submenu={item.item.submenu} />
            </li>
        );
    }
}
